const MESSAGE_DEFAULT = "MESSAGE_DEFAULT";
const MESSAGE_REJECTED = "MESSAGE_REJECTED";
const MESSAGE_FULFILLED = "MESSAGE_FULFILLED";
const MESSAGE_CLEAR = "MESSAGE_CLEAR";

export { 
    MESSAGE_DEFAULT,
    MESSAGE_REJECTED,
    MESSAGE_FULFILLED,
    MESSAGE_CLEAR
};